<template>
    <ai-grid-edit-core
        ref="gridRef"
        :meta="meta"
        :toolbar-config="toolbarConfig"
        :data-source="dataSource"
        :editing="editing"
    ></ai-grid-edit-core>
</template>

<script setup>
import AiGridEditCore from '@/components/ai-grid-edit/ai-grid-edit-core.vue';
import { onMounted, ref } from 'vue';

const gridRef = ref();
const gridInstance = ref();

onMounted(() => {
    gridInstance.value = gridRef.value?.gridInstance;
});

const toolbarConfig = {
    order: [
        {
            name: 'selectButton',
        },
        {
            name: 'refreshButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
    excluded: [],
    customTools: [
        {
            name: 'refreshButton',
            location: 'after',
            locateInMenu: 'auto',
            widget: 'dxButton',
            options: {
                hint: 'Обновить данные',
                icon: 'refresh',
            },
        },
    ],
};

const dataSource = [
    {
        name: 'Oliver Maldonado',
        phone: '1-223-697-7316',
        email: 'proin.vel@aol.com',
        id: 1,
        booleanProp: false,
    },
    {
        name: 'Lance Conway',
        phone: '(454) 546-3557',
        email: 'leo.vivamus@yahoo.net',
        id: 2,
        booleanProp: true,
    },
    {
        name: 'Amery Mcmillan',
        phone: '(925) 584-6382',
        email: 'pede.ultrices@google.couk',
        id: 3,
        booleanProp: true,
    },
    {
        name: 'Jena Grimes',
        phone: '1-307-701-5032',
        email: 'lacus.ut.nec@yahoo.couk',
        id: 4,
        booleanProp: true,
    },
    {
        name: 'Dalton Harrison',
        phone: '1-648-299-7487',
        email: 'vestibulum@protonmail.ca',
        id: 5,
        booleanProp: true,
    },
];

const meta = {
    keyExpr: 'id',
    focusedRowEnabled: true,
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            allowEditing: false,
            dataType: 'number',
        },
        {
            dataField: 'name',
            caption: 'Имя',
            dataType: 'string',
        },
        {
            dataField: 'phone',
            caption: 'Номер телефона',
            dataType: 'string',
        },
        {
            dataField: 'email',
            caption: 'Электронная почта',
            allowEditing: false,
            dataType: 'string',
        },
        {
            dataField: 'booleanProp',
            caption: 'Boolean колонка',
            dataType: 'boolean',
        },
    ],
};

const editing = {
    enableDeleting: true,
    allowAdding: true,
    allowUpdating: true,
};
</script>
